export function getTableViewSlug(): string {
  const searchParams = new URLSearchParams(window.location.search);
  for (const key of searchParams.keys()) {
    const match = key.match(/^(.+)_recordsPerPage$/);
    if (match) return match[1]; // returns 'inventory_items'
  }
  return "";
}
export default getTableViewSlug;